/*
 * @format
 */

import * as actionTypes from '../action-types';

const STATES = {
  NOT_STARTED: 'notStarted',
  STARTED: 'started',
  PENDING: 'pending',
  TIMEOUT: 'timeout',
  COMPLETE: 'complete',
};

export const initialState = {
  state: STATES.NOT_STARTED,
  error: '',
};

export const pendingCustomReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CUSTOM_PROPERTIES_UPDATE_STARTED:
      return {
        ...state,
        state: STATES.PENDING,
      };
    case actionTypes.CUSTOM_PROPERTIES_UPDATE_TIMEOUT:
      if (state.state === STATES.PENDING) {
        return {
          ...state,
          state: STATES.TIMEOUT,
        };
      }

      return state;
    case actionTypes.CUSTOM_PROPERTIES_UPDATE_COMPLETED:
      return initialState;
    case actionTypes.CUSTOM_PROPERTIES_UPDATE_RESET:
      return initialState;
    default:
      return state;
  }
};
